export const calculateAge = (birthDateStr) => {
  const birth = new Date(`${birthDateStr}T00:00:00`)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (Number.isNaN(birth.getTime()) || birth > today) return null

  let years = today.getFullYear() - birth.getFullYear()
  let months = today.getMonth() - birth.getMonth()
  let days = today.getDate() - birth.getDate()

  if (days < 0) {
    months -= 1
    const daysInPrevMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      0,
    ).getDate()
    days += daysInPrevMonth
  }
  if (months < 0) {
    years -= 1
    months += 12
  }

  const totalDays = Math.round((today - birth) / (1000 * 60 * 60 * 24))

  let nextBirthday = new Date(
    today.getFullYear(),
    birth.getMonth(),
    birth.getDate(),
  )
  if (nextBirthday < today) {
    nextBirthday = new Date(
      today.getFullYear() + 1,
      birth.getMonth(),
      birth.getDate(),
    )
  }
  const daysToNextBirthday = Math.round(
    (nextBirthday - today) / (1000 * 60 * 60 * 24),
  )

  return { years, months, days, totalDays, daysToNextBirthday }
}
